import { ROLES, CUSTOMER_ROLES } from '@/constants/roles';

export default [
  {
    path: '',
    name: 'Reporting',
    meta: {
      verticalMenu: {
        title: 'Reporting',
        icon: 'FileIcon',
        isGroup: true
      },
      roles: [ROLES.ADMIN, ROLES.ACCOUNT_ADMIN, ...CUSTOMER_ROLES]
    }
  },
  {
    path: '/reports/provider-invoice-upload',
    name: 'provider-invoice-upload',
    component: () => import('@/views/pages/reports/ProviderInvoiceUpload.vue'),
    meta: {
      verticalMenu: {
        title: 'Provider Invoice Upload',
        icon: 'UploadIcon',
        parent: 'Reporting'
      },
      roles: [ROLES.ADMIN, ROLES.ACCOUNT_ADMIN]
    }
  },
  {
    path: '/reports/create',
    name: 'reports-create',
    component: () => import('@/views/pages/reports/CreateReport.vue'),
    meta: {
      pageTitle: 'Create Report',
      verticalMenu: {
        title: 'Create Report',
        icon: 'PlusIcon',
        parent: 'Reporting'
      },
      roles: [ROLES.ADMIN, ROLES.ACCOUNT_ADMIN]
    }
  },
  {
    path: '/reports/ptt-reconciliation',
    name: 'reports-ptt-reconciliation',
    component: () => import('@/views/pages/reports/PttReconciliationReport.vue'),
    meta: {
      pageTitle: 'PTT Reconciliation Report',
      verticalMenu: {
        title: 'PTT Reconciliation Report',
        icon: 'BarChart2Icon',
        parent: 'Reporting'
      },
      roles: [ROLES.ADMIN, ROLES.ACCOUNT_ADMIN]
    }
  },
  {
    path: '/reports/shipment-status',
    name: 'reports-shipment-status',
    component: () => import('@/views/pages/reports/ShipmentStatusReport.vue'),
    meta: {
      pageTitle: 'Shipment Status Report',
      verticalMenu: {
        title: 'Shipment Status Report',
        icon: 'TruckIcon',
        parent: 'Reporting'
      },
      roles: [ROLES.ADMIN, ROLES.ACCOUNT_ADMIN]
    }
  },
  {
    path: '/reports/provider-performance',
    name: 'reports-provider-performance',
    component: () => import('@/views/pages/reports/ProviderPerformanceReport.vue'),
    meta: {
      pageTitle: 'Provider Performance Report',
      verticalMenu: {
        title: 'Provider Performance Report',
        icon: 'TrendingUpIcon',
        parent: 'Reporting'
      },
      roles: [ROLES.ADMIN, ROLES.ACCOUNT_ADMIN]
    }
  },
  {
    path: '/reports/package-declaration-change',
    name: 'reports-package-declaration-change',
    component: () => import('@/views/pages/reports/PackageDeclarationChangeReport.vue'),
    meta: {
      pageTitle: 'Package Declaration Change Report',
      verticalMenu: {
        title: 'Package Declaration Change Report',
        icon: 'PackageIcon',
        parent: 'Reporting'
      },
      roles: [ROLES.ADMIN, ROLES.ACCOUNT_ADMIN]
    }
  }
  // {
  //   path: '/reports/financial',
  //   name: 'reports-financial',
  //   redirect: '/reports/financial/activity',
  //   component: () => import('@/views/pages/reports/financial/Financial.vue'),
  //   meta: {
  //     verticalMenu: {
  //       title: 'Financial Reports',
  //       icon: 'BarChart2Icon',
  //       parent: 'Reporting'
  //     },
  //     roles: ['ROLE_ADMIN']
  //   },
  //   children: [
  //     {
  //       path: 'activity',
  //       name: 'reports-activity',
  //       component: () => import('@/views/pages/reports/financial/ActivityReport.vue')
  //     },
  //     {
  //       path: 'income-expense',
  //       name: 'reports-income-expense',
  //       component: () => import('@/views/pages/reports/financial/IncomeExpenseReport.vue')
  //     },
  //     {
  //       path: 'quantity',
  //       name: 'reports-by-quantity',
  //       component: () => import('@/views/pages/reports/financial/ReportByQuantity.vue')
  //     }
  //   ]
  // }
];
